module.exports = __webpack_public_path__ + "sap.450db076ae274c1ca4aeee2ccefe4ce2.png";